import { useRouter } from "@tanstack/react-router";
import { Crisp } from "crisp-sdk-web";
import { PropsWithChildren, useEffect } from "react";

interface Props extends PropsWithChildren {}

const getUrlVars = () => {
	const vars: Record<string, string> = {};

	window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, ...args) => {
		vars[args[0]] = args[1];
		return m;
	});
	return vars;
};

export const CrispProvider = ({ children }: Props) => {
	const router = useRouter();
	const pathname = router.state.location.pathname;

	useEffect(() => {
		Crisp.configure(import.meta.env.VITE_CRISP_WEBSITE_ID, {
			safeMode: true,
		});
		Crisp.chat.hide();

		const data: Record<string, string> = {};
		const urlVars = getUrlVars();

		for (const source of ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]) {
			const value = urlVars[source];
			if (value) {
				data[source] = value;
			}
		}

		if (Object.keys(data).length > 0) {
			Crisp.session.setData(data);
		}
	}, []);

	useEffect(() => {
		Crisp.session.setData({
			pathname,
		});
	}, [pathname]);

	return <>{children}</>;
};
